"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _angieslistReactComponents = require("angieslist-react-components");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _excluded = ["categories", "showXMark", "onCategoryClick"];
var styles = {
  buttonStyle: {
    margin: '.5em',
    borderRadius: '1.5em'
  },
  categoryList: {
    maxHeight: 300
  }
};
var CategoryList = function CategoryList(_ref) {
  var categories = _ref.categories,
    showXMark = _ref.showXMark,
    onCategoryClick = _ref.onCategoryClick,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: styles.categoryList
  }, (0, _map["default"])(categories).call(categories, function (category) {
    return /*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.Button, (0, _extends2["default"])({
      className: "new-category",
      key: category.id,
      id: "category-list-category-".concat(category.id),
      bsStyle: "primary",
      bsSize: "xsmall",
      flat: true,
      onClick: function onClick() {
        return onCategoryClick(category);
      },
      style: styles.buttonStyle
    }, props), category.name, showXMark ? /*#__PURE__*/_react["default"].createElement("i", {
      className: "icon icon-close"
    }) : null);
  }));
};
CategoryList.defaultProps = {
  categories: [],
  showXMark: true,
  onCategoryClick: function onCategoryClick() {}
};
CategoryList.propTypes = {
  categories: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].number,
    name: _propTypes["default"].string
  })),
  onCategoryClick: _propTypes["default"].func,
  showXMark: _propTypes["default"].bool
};
var _default = exports["default"] = CategoryList;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-composed-components/lib/category/categoryList.js
// module id = 6440
// module chunks = 25